(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('Authenticate', Authenticate);

    Authenticate.$inject = ['$rootScope'];

    function Authenticate($rootScope) {
        var _methods = {
            setPermissions: setPermissions,
            getPermissions: getPermissions,
            hasPermission: hasPermission,
            permissionList: null
        };

        return _methods;

        function setPermissions(permissions) {
            _methods.permissionList = permissions;
            // can be used in the future for real-time permission
            // $rootScope.$broadcast('permissionsChanged');
        }

        function getPermissions() {
            return _methods.permissionList;
        }

        function hasPermission(permission) {
            permission = permission.trim();

            if (_methods.getPermissions().indexOf(permission) !== -1) {
                return true;
            } else {
                return false;
            }
        }

    }
})();